import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/apiClient';
import queryClient from '../../lib/queryClient';
import useDataDog from '../../reporting/DataDog';
import { QUERY_KEY_USER_TERMS } from './useTerms';

const useMarkTermsAsSeen = () => {
  const { addError, addAction } = useDataDog();

  return useMutation({
    mutationKey: ['markTermsAsSeen'],
    mutationFn: ({ termsDocumentUuid }: { termsDocumentUuid: string; refetch?: boolean }) => {
      return apiClient.post(`api/supplier-experience/user/terms/${termsDocumentUuid}/seen`).json();
    },
    onSuccess: (_data, { termsDocumentUuid, refetch }) => {
      addAction('enterprise::user-terms::seen::success', {
        message: `User terms ${termsDocumentUuid} marked as seen`,
        termsDocumentUuid,
      });
      if (refetch) {
        // Refetch the terms to update the seen status in the UI
        queryClient.refetchQueries({
          queryKey: [QUERY_KEY_USER_TERMS],
        });
      }
    },
    onError: (error, { termsDocumentUuid }) => {
      addError('enterprise::user-terms::seen::error', {
        error,
        termsDocumentUuid,
      });
    },
  });
};

export default useMarkTermsAsSeen;
